import React from "react";
import { CardsDeckInfoBox } from "../../CardsDeckWithTitle/CardsDeckInfoBox";
export const ImportantNote = ({ text, mustShowImportantNote = true, className }) => {
    if (text && mustShowImportantNote) {
        return React.createElement(CardsDeckInfoBox, { text: text, className: `cards-deck-info-box--width-auto ${className ? ` ${className}` : ""}` });
    }
    return null;
};
